import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {Injectable} from "@angular/core";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {ExecTrader} from "../../model/customer/exec-trader";

@Injectable({
  providedIn: 'root'
})
export class CustomerExecTraderService extends CommonCrudService<ExecTrader> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_EXEC_TRADER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_EXEC_TRADER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_EXEC_TRADER);
  }

}
